module.exports = __webpack_public_path__ + "img/r8.bf7e478b.jpg";